<template>
    <UIDialog :open="open" @update:open="$emit('close')">
        <DialogScrollContent class="w-full max-w-2xl rounded-lg bg-white p-4">
            <DialogHeader>
                <DialogTitle> Preview Email {{ currentIndex + 1 }} of {{ emails.length }} </DialogTitle>
            </DialogHeader>

            <div v-if="emails.length > 0" class="mt-4 space-y-4">
                <div class="text-sm"><strong>To:</strong> {{ current.to }}</div>

                <div class="text-sm"><strong>Subject:</strong> {{ current.subject }}</div>

                <div
                    class="prose h-[300px] max-w-none overflow-y-auto rounded-md border bg-slate-50 p-3"
                    v-html="current.body"
                ></div>
            </div>

            <div v-else class="py-10 text-center text-slate-500">No emails to preview.</div>

            <div class="mt-6 flex items-center justify-between">
                <div class="flex gap-2">
                    <Button variant="outline" :disabled="currentIndex === 0 || emails.length === 0" @click="prev">
                        Previous
                    </Button>

                    <Button
                        variant="outline"
                        :disabled="currentIndex === emails.length - 1 || emails.length === 0"
                        @click="next"
                    >
                        Next
                    </Button>
                </div>
                <div class="flex gap-2">
                    <Button variant="outline" @click="$emit('close')">Cancel</Button>
                    <Button :disabled="emails.length === 0" @click="$emit('confirm')"> Send All </Button>
                </div>
            </div>
        </DialogScrollContent>
    </UIDialog>
</template>

<script>
import { Dialog, DialogHeader, DialogTitle, DialogScrollContent } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'

export default {
    name: 'EmailPreviewModal',

    components: {
        UIDialog: Dialog,
        DialogHeader,
        DialogTitle,
        DialogScrollContent,
        Button,
    },

    props: {
        open: Boolean,
        emails: Array,
    },

    emits: ['close', 'confirm'],

    data() {
        return {
            currentIndex: 0,
        }
    },

    computed: {
        current() {
            return this.emails[this.currentIndex] || {}
        },
    },

    watch: {
        open(newVal) {
            if (newVal) {
                this.currentIndex = 0
            }
        },
    },

    methods: {
        next() {
            if (this.currentIndex < this.emails.length - 1) this.currentIndex++
        },
        prev() {
            if (this.currentIndex > 0) this.currentIndex--
        },
    },
}
</script>
